export default __webpack_public_path__ + "static/report-image-four-57784996664ef7c341430411589d99d7.png";